module.exports = __webpack_public_path__ + "img/instagram.b2924b31.svg";